import React, { useMemo } from 'react';
import Text from '../Text';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { AvailableLanguages } from '../../utils/langaugeTypes';

export type NavigationItem = {
  text: string;
  href: string;
  language?: AvailableLanguages;
  icon?: React.ReactNode;
};

const NavigationGroup: React.FC<{ items: NavigationItem[] }> = ({ items }) => {
  const { t } = useTranslation();

  const Items = useMemo(
    () =>
      items.map((item) => (
        <div
          key={item.text}
          className={`navigation-group__item ${item.href && 'navigation-group__item_link'} `}
        >
          <Text
            color="light"
            type="p"
            className="light-mode"
            href={t(item.href)}
            language={item.language}
            weight="demi-bold"
          >
            {t(item.text)}
          </Text>
        </div>
      )),
    [items, t]
  );

  return <div className="navigation-group">{Items}</div>;
};

export default React.memo(NavigationGroup);
